import { Room, TwilioError } from "twilio-video";
import { useEffect } from "react";
import { Callback } from "../../../types";
import { useToasterContext } from "../../../hooks/useToasterContext/useToasterContext";

export const useHandleRoomDisconnection = (
	room: Room | null,
	onError: Callback,
	removeLocalAudioTrack: () => void,
	removeLocalVideoTrack: () => void,
	isSharingScreen: boolean,
	toggleScreenShare: () => void
): void => {
	const { toaster } = useToasterContext();

	useEffect(() => {
		if (room) {
			const onDisconnected = (_: Room, error: TwilioError) => {
				if (error?.code === 53118) {
					console.log("[CIPTEX] The event has been ended by the host");
					toaster.push({
						message: "The event has been ended by the host.",
						variant: "neutral",
						dismissAfter: 4000
					});
				} else if (error) {
					console.error(error);
					onError(error);
				}

				removeLocalAudioTrack();
				removeLocalVideoTrack();
				if (isSharingScreen) {
					toggleScreenShare();
				}
			};

			room.on("disconnected", onDisconnected);
			return () => {
				room.off("disconnected", onDisconnected);
			};
		}
	}, [
		room,
		onError,
		removeLocalAudioTrack,
		removeLocalVideoTrack,
		isSharingScreen,
		toggleScreenShare
	]);
}
